import firebase from "firebase/app";

import { AnalyticsEventEnum } from "@/consts/AnalyticsEventEnum";
import { DialogViewEnum, useDialog } from "@/features/common/hooks/useDialog";
import { useErrorHandling } from "@/features/common/hooks/useErrorHandling";
import { useWalletValidation } from "@/features/nft/hooks/useWalletValidation";

import { useEth721CancelList } from "./useEth721CancelList";

type UseOnClickEth721CancelListArgs = {
  tokenId: string;
  postId: string;
  logEvent?: AnalyticsEventEnum;
};

export const useOnClickEth721CancelList = ({
  tokenId,
  postId,
  logEvent = AnalyticsEventEnum.NftPostContentActionMenuUnlist,
}: UseOnClickEth721CancelListArgs) => {
  const { openDialog } = useDialog();
  const isWalletValid = useWalletValidation();
  const { handleEthError } = useErrorHandling();

  const cancelList = useEth721CancelList();

  const onClickCancelList = () => {
    firebase.analytics().logEvent(logEvent, {
      postId,
      tokenId,
    });

    if (!isWalletValid()) return;

    const onConfirm = async () => {
      try {
        await cancelList({ tokenId });
      } catch (error) {
        handleEthError({
          extra: { tokenId },
          functionName: "Cancel List",
          error,
        });
      }
    };

    openDialog({
      view: DialogViewEnum.CancelListDialog,
      tokenId,
      onConfirm,
    });
  };
  return onClickCancelList;
};
